import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route } from "react-router-dom";
  import { useHistory,} from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {Link } from "react-router-dom";
import ContentMenuCard from "./ContentMenuCard";
import CreateCourseCurriculum from "./CreateCourseCurriculum";
import CreateCourseSubcourseAndMilestones from "./CourseSubCourseAndMilestones";
import CreateCourseDrip from "./CreateCourseDrip";
import CreateCourseAssignmentAnalytics from "./CourseAssignmentAnalytics";
import CreateCourseSubmissions from "./CourseSubmissions";
import CreateCourseCommentsAndQnA from "./CourseCommentsAndQnA";
import CreateCourseReportsAndReviews from "./CourseReportsAndReviews";
import AppMenuCardTwo from "../CreateApp/Cards/AppMenuCardTwo";
import SelectCourseInReduxPopUp from "./SelectCourseInReduxPopUp";
// npm i @loadable/component 
import {X,Plus ,Star,Settings,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ProductMenuRightCard from "../../MyApps/AppCards/ProductMenuRightCard";
import MyCourses from "../../MyApps/MyCourses";
import AdminCourseBatchesCard from "../Batches/AdminCourseBatchesCard";
import AdminBatchDashboardCard from "../Batches/AdminBatchDashboardCard";
import AdminCourseBatcheDash from "../Batches/AdminCourseBatcheDash";
import ActivityLogScreen from "../Notification/screens/ActivityLogScreen";
import AutomationListScreen from "../Notification/screens/AutomationListScreen";
import CreateAutomationScreen from "../Notification/screens/CreateAutomationScreen";
import AutomationDetailScreen from "../Notification/screens/AutomationDetailScreen";
import CreateCampaignScreen from "../Notification/screens/CreateCampaignScreen";
import CampaignListScreen from "../Notification/screens/CampaignListScreen";
import EmailTemplatesPage from "../EmailTemplates/components/EmailTemplatesPage";
import EditCampaignScreen from "../Notification/screens/EditCampaignScreen";
import CampaignDetailScreen from "../Notification/screens/CampaignDetailScreen";

  
 const  CreateContent = ()=>{
      const {url}=useRouteMatch();
   const history = useHistory();
          const [activeCardFolder, setActiveCardFolder] =useState(true);
         const [activeCardOrganize, setActiveCardOrganize] =useState(false);
         const [activeCardDrip, setActiveCardDrip] =useState(false);
         const [activeCardAnalytics, setActiveCardAnalytics] =useState(false);
         const [activeCardSubmissions, setActiveCardSubmissions] =useState(false);
         const [activeCardQnA, setActiveCardQnA] =useState(false);
         const [activeCardReviews, setActiveCardReviews] =useState(false);
          const [colorThemeGrid, setColorThemeGrid] =useState(true);   
          const [colorThemeList, setColorThemeList] =useState(false);   
          const [selectCoursePopUp, setSelectCoursePopUp] =useState(false);   
          const [productMenuRightCardPrice, setProductMenuRightCardPrice] = useState(false);
          
                                                      const [designContent, openDesignContent] =useState(false);    
                                     const [activeCardOverview, setActiveCardOverview] =useState(false);
                                                                         const [activeCardScreens, setActiveCardScreens] =useState(false);
                                                                         const [activeCardElements, setActiveCardElements] =useState(false); 
                                                                         const [activeCardSettings, setActiveCardSettings] =useState(false);   
                                                                         const [fixMenuAppRight, closeFixMenuAppRight] =useState(false);   
                                                                          const [openAppDesignPopUpInn,setopenAppDesignPopUpInn]  = useState(false);
                                                                          const rightFixClose =fixMenuAppRight?"-50%":"30px";
                                                                          const rightFixOpen =fixMenuAppRight?"30px":"-50%";
                                                                          const fixMenuAppRightHide={width:"70px",right:rightFixOpen,height:"80px"}
                                                                          const fixMenuAppRightShow={width:"70px",right:rightFixClose}
                                                                        
                                                                          
           const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
           const courseName = useSelector((state)=>state?.course?.course?.CourseName);
                const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
         const [deviceWidth,setDeviceWidth] = useState(false);
         const bottomDivRef = useRef(null);
         
         const bottomDivBoxRef = useRef(null);
         const bodyWidthForMobile =useRef(null)
         
         const [isVisible, setIsVisible] = useState(false);
       
         const [divHeight, setDivHeight] = useState(0);
         
            const dispatch = useDispatch();
         const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        }
        
         const token = useSelector((state)=>state?.course?.course?.token);
         const currentToken = useSelector((state)=>state?.user?.user?.token);
         const user_email = useSelector((state)=>state?.user?.user?.user_email
        );
        
        const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
        
        const courseData = useSelector((state)=>state?.course?.course);
        
        const [currentAppCourses, setCurrentAppCourses] =useState(false)
        
        useEffect(() => {
         
          // if(courseName){}else{setSelectCoursePopUp(true);}


           if (bodyWidthForMobile.current) {
             let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
               setDeviceWidth(offsetWidth)
           }
           setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
           const observer = new IntersectionObserver(
             ([entry]) => {
               if (entry.isIntersecting) {
                 setIsVisible(true); // Set state when the div appears
               } else {
                 setIsVisible(false); // Reset state if it goes out of view
               }
             },
             {
               root: null, // Observe within the viewport
               threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
             }
           );
       
           if (bottomDivRef.current) {
             observer.observe(bottomDivRef.current);alert("jj")
           }
       
           return () => {
             if (bottomDivRef.current) {
               observer.unobserve(bottomDivRef.current);
             }
           };
         }, [deviceWidth])
     
 


    return <div> 
      <div  ref={bodyWidthForMobile}   className="outer-right ">
  
   
 <div className="gridForCreateContentOuterAll " style={{ position:"relative",marginTop:"-25px"}}   >
 <div className="coursePreviewAllOuterGrid" style={{ minHeight:"70vh", position:"relative"}}  >
     
     
      <div className=""
      // {`
      // ${!isVisible?"fixed-div-themes":"normal-div-last-themes"} 
      //  `}
        style={{ textAlign:"left",left:deviceWidth>551?mainMenuStatus?"270px":"170px":"0px",
          backgroundColor:"transparent",marginBottom:`${!isVisible?0:-divHeight}px ` ,marginTop:"0px"}} >
        <ContentMenuCard activeCard={activeCardFolder}  icon={6} title ="Organize  " onClickPopup={
          ()=>{setActiveCardFolder(true);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
              history.push(`${url}`) }}  />
        <ContentMenuCard activeCard={activeCardOrganize}  icon={2} title ="Batches & Drip" onClickPopup={
          ()=>{setActiveCardFolder(false);setActiveCardOrganize(true);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
            history.push(`${url}/batches`) }}  />
                {/* <ContentMenuCard activeCard={activeCardReviews} icon={1} title ="Webinar & CRM" onClickPopup={
          ()=>{  setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(false); setActiveCardQnA(false);setActiveCardReviews(true);
             history.push(`${url}/reports-reviews`) }}  /> */}
     
        {/* <ContentMenuCard activeCard={activeCardDrip} icon={7} title ="Ads & Funnels" onClickPopup={()=>{
          setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(true);setActiveCardAnalytics(false);
          setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
          history.push(`${url}/drip`)}}  /> */}
         {/* <ContentMenuCard activeCard={activeCardSubmissions} icon={4} title ="Notifications " onClickPopup={
          ()=>{ setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
            setActiveCardSubmissions(true);setActiveCardQnA(false);setActiveCardReviews(false);
            history.push(`${url}/notifications`)  }}  /> */}
         {/* <ContentMenuCard activeCard={activeCardAnalytics} icon={3} title ="Batches Revenue" onClickPopup={
          ()=>{setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(true);
            setActiveCardSubmissions(false);setActiveCardQnA(false);setActiveCardReviews(false);
          history.push(`${url}/assignment-analytics`) }}  /> */}
        <ContentMenuCard activeCard={activeCardQnA} icon={5} title ="User Feedback" onClickPopup={()=>{
          setActiveCardFolder(false);setActiveCardOrganize(false);setActiveCardDrip(false);setActiveCardAnalytics(false);
          setActiveCardSubmissions(false); setActiveCardQnA(true);setActiveCardReviews(false);
           history.push(`${url}/comments-qna`)  }}  />
     </div>  
         </div><div><div  className="gridRightLittleSpace"><div>
          <div className="CoursesFilterTw  " style={{zIndex:"99",marginTop:"0px"}} >
                  <div className="CoursesFilterLeft" style={{zIndex:"99"}} >
          {/*           
                    <div  className="CoursesFilterTopTitle" >Course </div>
                  <Link to={`/dashboard/create-course/course-name`}>   
                   <div   className="CoursesFilterTopBtn"> Preview Course</div></Link> */}
          
                  
          {/* <div   className=" progress-bar-container "> 
             <div className="progress-bark">
                  {steps.map((step, index) => (
                    <div
                      key={index}
                      className={`circlek ${index <= activeStep ? "activek" : ""}` }
                      style={{background: `${step ===1?
                        `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                          ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                          step ===2?
                                                          `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                          ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                          ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                          step ===3?
                                                          `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                          ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                          ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                          :step ===4?
                                                          `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                          ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                          ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                          step ===5?
                                                          `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                          ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                          ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
                      `}} 
                    ><div   className={`circlekInn `}>
                       {step}
                    </div>
                     
                    </div>
                  ))}
                </div>  
              
                </div> */}
              <div align="left" className="gridForTopSelectCOuseSetting" style={{borderRadius:"15px",paddingLeft:"20px"}} >
              <div align="left" className="gridForTopSelectCOuseSetting" style={{borderRadius:"15px",paddingLeft:"20px"}} ><h3 className="ButtonWithEllipsis"  >Course: {courseData?.productName}</h3> 
       
    
       {/* <Link  to={`/apps/${AppToken}/my-courses`} ><h3 style={{fontSize:"14px",color:"rgba(144, 202, 249,1)",marginTop:"20px"}}>
         Change Course</h3></Link>  */}
    <Link to={`/apps/${AppToken}/create/course-name`}> <Settings style={{padding:"20px",float:"right"}} color="#958FDA" size="20"/></Link> 
          </div>   
              
                 <h3   onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}  onClick={()=>{setCurrentAppCourses(true)}} style={{fontSize:"14px",color:"rgba(144, 202, 249,1)",cursor:"pointer",
                marginTop:"15px",border:"2px dashed rgba(144, 202, 249,1)",padding:"10px",borderRadius:"10px",width:"40px"}}>
                   Change</h3>
                 
                    </div>
                   </div> {courseData?<div><div className="CoursesFilterRight" style={{zIndex:"99"}} >
                   <div className=""><div
                    onClick={ ()=>{      
                      history.push(`/preview-course/`)}}
                    onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}  className=" CoursesPreviewTopBtn"> Preview Course</div>
          
               </div>
              <div className=""><div  onClick={()=>{setCurrentAppCourses(true)}} onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} className="CoursesCreateTopBtn">  Show All</div> 
           {/* <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} className="CoursesCreateTopBtn">  Manage
             <div   className=" CoursesCreateTopBtnInn " style={{width:"220px"}}>  
               <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn" 
               style={{background:"rgba(149, 143, 218,0.8)",color:"#fff",width:"180px"}}> +Create A Batch </div>
               <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn"style={{width:"180px"}}>Add To Membership Plan </div>
               <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} style={{width:"180px",border:"0px solid #fff"}}  
               className="CoursesCreateTopBtn">Add To Course Bundle </div>
                 {/* <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} style={{background:"rgba(149, 143, 218,0.8)",width:"180px",color:"#fff",border:"0px solid #fff"}}  
               className="CoursesCreateTopBtn">+Create Podcast </div> */}
                {/* </div>  */}
             {/* </div> */} 
           <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{     history.push(`/apps/${AppToken}/create/content`)}}
               className="CoursesCreateTopBtn"> + Content </div> 
               
           {/* <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{    dispatch({
                type: "COURSEDATA",
                
                payload:""
              });   history.push(`/apps/${AppToken}/create/course-name`);    }}
               className="CoursesCreateTopBtn"> + New </div>  */}
             </div>
             </div>    </div>:""}
             
             </div>
         
       
      {selectCoursePopUp?<SelectCourseInReduxPopUp selectCoursePopUp={(selectCoursePopUp)=>{setSelectCoursePopUp(selectCoursePopUp);}} />:""}
{currentAppCourses?<MyCourses setCurrentAppCourses={()=>{setCurrentAppCourses(false)}}/>:""}
          <Switch>
    <Route exact path={`${url}/`}>
{!selectCoursePopUp?<CreateCourseSubcourseAndMilestones selectCoursePopUp={(selectCoursePopUp)=>{setSelectCoursePopUp(selectCoursePopUp);}} />:""}
    </Route>
    <Route   path={`${url}/batches`}>
  <AdminCourseBatcheDash 
         />
</Route> 
<Route path={`${url}/drip`}>
<CreateCourseDrip />
</Route>
<Route path={`${url}/assignment-analytics`}>
<CreateCourseAssignmentAnalytics />
</Route>
<Route path={`${url}/submissions`}>
<CreateCourseSubmissions />
</Route>
<Route path={`${url}/comments-qna`}>
<CreateCourseCommentsAndQnA />
</Route>
<Route path={`${url}/reports-reviews`}>
<CreateCourseReportsAndReviews />
</Route>
<Route exact path={`${url}/notifications`}>
<CreateCampaignScreen />
<EmailTemplatesPage />
{/* 


<CreateAutomationScreen />
<AutomationDetailScreen />
<AutomationListScreen/>
<ActivityLogScreen /> */}
</Route>
<Route exact path={`${url}/notifications/campaigns`}>
<CampaignListScreen/></Route>
<Route path={`${url}/notifications/campaigns/edit/:id?`}>
<EditCampaignScreen /></Route>
<Route path={`${url}/notifications/campaigns/:id?`}>
<CampaignDetailScreen /></Route>


</Switch></div>
      </div></div></div>
      <div style={{padding:"10px",}} ref={bottomDivBoxRef}></div>
      </div><div>
      </div>
      </div>}
export default CreateContent;
